var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoDataFoundIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "306px",
    height: "174px",
    viewBox: "0 0 306 174",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "21F25DB3-ADCF-4935-8898-E9B953457959") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REIS_Wiregrame-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REIS_Properties_No-Data-Found",
    transform: "translate(-474.000000, -322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(474.000000, 322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.999867,22.5657704 C287.695502,101.083505 226.130097,158.823069 152.999933,158.823069 C79.8697693,158.823069 18.3043649,101.083505 2.22488694e-13,22.5657704 Z",
    id: "Combined-Shape",
    fill: "#D8D8D8",
    opacity: 0.120832897,
    transform: "translate(152.999933, 90.694420) rotate(180.000000) translate(-152.999933, -90.694420) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(50.591894, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.041206,126.576603 L93.041206,157.026442 L56.5176597,157.026442 C52.5135953,157.026442 48.8885953,155.403474 46.2646114,152.77949 C43.6406275,150.155506 42.0176597,146.530506 42.0176597,142.526442 L42.0176597,126.576603 L93.041206,126.576603 Z",
    id: "Rectangle",
    stroke: "#757575",
    strokeWidth: 3,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.016458,31.9206769 L157.016458,157.026442 L54.8127101,157.026442 L54.8127101,31.9206769 L157.016458,31.9206769 Z",
    id: "Rectangle",
    stroke: "#757575",
    strokeWidth: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#D8D8D8",
    opacity: 0.663469587,
    cx: 109.468765,
    cy: 95.8969568,
    rx: 39.0959874,
    ry: 39.1434282
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(132.926357, 100.167149) rotate(-57.000000) translate(-132.926357, -100.167149) translate(93.830370, 36.825965)",
    stroke: "#757575"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 2.5,
    fill: "#D8D8D8",
    x: 37.5026429,
    y: 75.9783629,
    width: 3.18668908,
    height: 7.46378172
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 3,
    fill: "#A3A4A4",
    x: 35.6201345,
    y: 85.480446,
    width: 6.95170589,
    height: 39.7019217,
    rx: 3.47585295
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 3,
    fill: "#A3A4A4",
    x: 31.3551177,
    y: 84.0570486,
    width: 15.4817395,
    height: 2.69358956,
    rx: 1.34679478
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    strokeWidth: 3,
    fill: "#D8D8D8",
    cx: 39.0959874,
    cy: 39.1434282,
    rx: 37.5959874,
    ry: 37.6434282
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-2",
    strokeWidth: 3,
    fill: "#FFFFFF",
    cx: 39.0959874,
    cy: 39.1434282,
    rx: 29.7767899,
    ry: 29.8147426
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(74.637794, 50.348240)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#757575",
    cx: 103.07124,
    cy: 83.7980789,
    rx: 2.84334454,
    ry: 2.84679478
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#757575",
    cx: 124.396324,
    cy: 83.7980789,
    rx: 2.84334454,
    ry: 2.84679478
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.0953866,
    y1: 80.9512842,
    x2: 104.023237,
    y2: 77.9334932,
    id: "Path-16",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.396324,
    y1: 80.780288,
    x2: 129.372177,
    y2: 77.3927907,
    id: "Path-16-Copy",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(126.884250, 79.172037) scale(1, -1) translate(-126.884250, -79.172037) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#757575",
    cx: 113.733782,
    cy: 96.6086554,
    rx: 2.13250841,
    ry: 3.55849347
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.2767899,
    y1: 157.814743,
    x2: 172.022345,
    y2: 157.814743,
    id: "Path-17",
    stroke: "#757575",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.0600672,
    y1: 157.814743,
    x2: 23.4575925,
    y2: 157.814743,
    id: "Path-17-Copy",
    stroke: "#757575",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.709034,
    y1: 157.814743,
    x2: 181.974051,
    y2: 157.814743,
    id: "Path-17-Copy-2",
    stroke: "#757575",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.8545169,
    y1: 100.167149,
    x2: 120.131307,
    y2: 70.8115325,
    id: "Path-18",
    stroke: "#979797",
    strokeWidth: 3,
    opacity: 0.0994139172,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4976686,98.7437515 C97.829586,98.259132 102.767733,93.4617829 112.312109,84.3517044",
    id: "Path-19",
    stroke: "#979797",
    strokeWidth: 3,
    opacity: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    id: "?",
    opacity: 0.391536894,
    transform: "translate(26.656355, 88.424120) rotate(-36.000000) translate(-26.656355, -88.424120) ",
    fontFamily: "SFProText-Bold, SF Pro Text",
    fontSize: 33,
    fontWeight: "bold",
    letterSpacing: -0.384685583,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 17.1563551,
    y: 99.9241205
  }, "?")), /*#__PURE__*/React.createElement("text", {
    id: "?-copy-2",
    opacity: 0.391536894,
    transform: "translate(186.594485, 111.910177) rotate(22.000000) translate(-186.594485, -111.910177) ",
    fontFamily: "SFProText-Bold, SF Pro Text",
    fontSize: 33,
    fontWeight: "bold",
    letterSpacing: -0.384685583,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 177.094485,
    y: 123.410177
  }, "?")), /*#__PURE__*/React.createElement("text", {
    id: "?-copy",
    opacity: 0.113284156,
    transform: "translate(190.325800, 62.143166) rotate(20.000000) translate(-190.325800, -62.143166) ",
    fontFamily: "SFProText-Bold, SF Pro Text",
    fontSize: 59,
    fontWeight: "bold",
    letterSpacing: -0.687771194,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 161.8258,
    y: 83.1431659
  }, "?")), /*#__PURE__*/React.createElement("text", {
    id: "?-copy-3",
    opacity: 0.113284156,
    fontFamily: "SFProText-Bold, SF Pro Text",
    fontSize: 41,
    fontWeight: "bold",
    letterSpacing: -0.477942694,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 27.3191613,
    y: 39
  }, "?")), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    opacity: 0.476130894,
    transform: "translate(35.541807, 74.545996)",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20-Copy",
    transform: "translate(2.487926, 2.135096) scale(1, -1) translate(-2.487926, -2.135096) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    opacity: 0.476130894,
    transform: "translate(43.361004, 105.860738)",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20-Copy",
    transform: "translate(2.487926, 2.135096) scale(1, -1) translate(-2.487926, -2.135096) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-2",
    opacity: 0.476130894,
    transform: "translate(163.492311, 40.384459)",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20-Copy",
    transform: "translate(2.487926, 2.135096) scale(1, -1) translate(-2.487926, -2.135096) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    opacity: 0.476130894,
    transform: "translate(86.011172, 12.628209)",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20-Copy",
    transform: "translate(2.487926, 2.135096) scale(1, -1) translate(-2.487926, -2.135096) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-6",
    opacity: 0.476130894,
    transform: "translate(181.974051, 88.779970)",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20-Copy",
    transform: "translate(2.487926, 2.135096) scale(1, -1) translate(-2.487926, -2.135096) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-5",
    opacity: 0.476130894,
    transform: "translate(0.000000, 105.860738)",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4.97585295,
    y2: 4.27019217,
    id: "Path-20-Copy",
    transform: "translate(2.487926, 2.135096) scale(1, -1) translate(-2.487926, -2.135096) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    opacity: 0.476130894,
    transform: "translate(166.335656, 98.743752)",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 3.55418068,
    y2: 2.84679478,
    id: "Path-20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 3.55418068,
    y2: 2.84679478,
    id: "Path-20-Copy",
    transform: "translate(1.777090, 1.423397) scale(1, -1) translate(-1.777090, -1.423397) "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    opacity: 0.7,
    transform: "translate(131.576964, 48.577952) rotate(-4.000000) translate(-131.576964, -48.577952) translate(123.792671, 43.493020)",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(-0.000000, 0.377861)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2.27373675e-13,
    y1: 2.12003803,
    x2: 8.20257479,
    y2: 9.79200373,
    id: "Path-21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4851175,
    y1: 0.934028664,
    x2: 15.4103349,
    y2: 3.82955082,
    id: "Path-21-Copy-2",
    transform: "translate(13.447726, 2.381790) scale(1, -1) rotate(66.000000) translate(-13.447726, -2.381790) "
  })), /*#__PURE__*/React.createElement("line", {
    x1: 5.90765705,
    y1: 0.488581506,
    x2: 11.5744666,
    y2: 6.15539104,
    id: "Path-21-Copy",
    transform: "translate(8.741062, 3.321986) scale(1, -1) rotate(79.000000) translate(-8.741062, -3.321986) "
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoDataFoundIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NoDataFoundIcon.d47ad3dd57c6fad17e2a8d88233463e6.svg";